export class PortalError {
    userId?: string;
    browserAgent?: string;
    errorMessage?: string;
    friendlyErrorMessage?: string;
    status: number;
}
